/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable no-console */
/* eslint-disable unicorn/consistent-function-scoping */
import { UserPreferenceNames } from './types';
import { searchActionNames } from '../search/types';
import UserPreferences from '../../services/user-preferences-v2';
import { AppState, AppThunkDispatch } from '..';
import { GlobalPreferences } from '../../entities/user-preferences-v2/global-preferences';

export const getCustomUserPreferences =
  (preferences?: string) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const service = new UserPreferences(client, envVariables.userPreferencesV2BaseUrl);
    const response: any = await service.getCustomUserPreferences(preferences);
    if (response.data.recentlyViewedSearches) {
      dispatch({
        type: UserPreferenceNames.SET_RECENT_USER_SEARCHES,
        payload: response.data.recentlyViewedSearches,
      });
      const searchesObject = JSON.parse(response.data.recentlyViewedSearches);
      dispatch({
        type: searchActionNames.SET_RECENT_SEARCHES,
        payload: searchesObject,
      });
    }
    if (response.data.timeZone) {
      dispatch({
        type: UserPreferenceNames.SET_TIME_ZONE,
        payload: response.data.timeZone,
      });
    }
    if (response.data.displayName !== '')
      dispatch({
        type: UserPreferenceNames.SET_DISPLAY_NAME,
        payload: response.data.displayName,
      });
    else
      dispatch({
        type: UserPreferenceNames.SET_DISPLAY_NAME,
        payload: 'Jane Doe',
      });
  };

export const getGlobalUserPreferences =
  () => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const service = new UserPreferences(client, envVariables.userPreferencesV2BaseUrl);
    const response: any = await service.getGlobalUserPreferences();
    if (response.data && response.data.userProvided) {
      if (response.data.userProvided.dateFormat) {
        dispatch({
          type: UserPreferenceNames.SET_DATE_FORMAT,
          payload: response.data.userProvided.dateFormat,
        });
      }
      if (response.data.userProvided.timeFormat) {
        dispatch({
          type: UserPreferenceNames.SET_TIME_FORMAT,
          payload: response.data.userProvided.timeFormat,
        });
      }
    }
  };

export const setSessionHistory =
  ({ page, deviceId, queryString }: { page: any; deviceId: any; queryString: any }) =>
  (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      userPreference: { sessionHistory },
    } = getState();
    const newSessionHistory = { ...sessionHistory, [page]: { deviceId, queryString } };
    dispatch({ type: UserPreferenceNames.SET_SESSION_HISTORY, payload: newSessionHistory });
  };

export const setUserProfileName =
  (newDisplayName: string) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const service = new UserPreferences(client, envVariables.userPreferencesV2BaseUrl);
    await service
      .modifyCustomUserPreferences({ displayName: newDisplayName })
      .catch((error) => console.error('error saving display name', error));
    dispatch({ type: UserPreferenceNames.SET_DISPLAY_NAME, payload: newDisplayName });
  };

export const setTimeZone =
  (newTimeZone: string) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const service = new UserPreferences(client, envVariables.userPreferencesV2BaseUrl);
    await service
      .modifyCustomUserPreferences({ timeZone: newTimeZone })
      .catch((error) => console.error('error saving time zone', error));
    dispatch({ type: UserPreferenceNames.SET_TIME_ZONE, payload: newTimeZone });
  };

export const setDateFormat =
  (newDateFormat: GlobalPreferences.DateFormatEnum) =>
  async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
      userPreference: { globalUserPreferences },
    } = getState();
    const service = new UserPreferences(client, envVariables.userPreferencesV2BaseUrl);
    await service
      .setGlobalUserPreferences({ ...globalUserPreferences, dateFormat: newDateFormat })
      .catch((error) => console.error('error saving date format', error));
    dispatch({ type: UserPreferenceNames.SET_DATE_FORMAT, payload: newDateFormat });
  };

export const setTimeFormat =
  (newTimeFormat: GlobalPreferences.TimeFormatEnum) =>
  async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
      userPreference: { globalUserPreferences },
    } = getState();
    const service = new UserPreferences(client, envVariables.userPreferencesV2BaseUrl);
    await service
      .setGlobalUserPreferences({ ...globalUserPreferences, timeFormat: newTimeFormat })
      .catch((error) => console.error('error saving time format', error));
    dispatch({ type: UserPreferenceNames.SET_TIME_FORMAT, payload: newTimeFormat });
  };
